module.exports = __webpack_public_path__ + "img/CSLHSC-4.c9a3ec83.png";